const Expenses = () => {
    return <div id="Expenses" className="card">
        <h2>Expenses</h2>
        <h3>-$234.22</h3>
        <button>View Details</button>
    </div>
}

export default Expenses;